<template>

	<div class="g-facet-set__list">
		<label class="g-facet-set__list-item g-form-checkbox" v-for="value in facet.values.slice(0, facet.overflow.limit)" :key="value.label">
			<input class="g-form-checkbox__input" v-model="value.active" type="checkbox" @click="toggleFilter( facet.field, value.type === 'value' ? value.value : [value.low, value.high] )">
			<span class="g-facet-set__list-item-link g-form-checkbox__caption">
				<span class="g-facet-set__list-item-name">{{ value.label }}</span>
				<span class="g-facet-set__list-item-count">({{ value.count }})</span>
			</span>
		</label>
		<div class="g-facet-view-more" v-if="( facet.values.length > facet.overflow.limit )">
			<input :id="'g-facet-view-more__' + facet.field" class="g-facet-view-more__checkbox u-hide-visually" type="checkbox" @change="viewMoreChange">
			<label class="g-facet-view-more__label" :for="'g-facet-view-more__' + facet.field">View More</label>
			<div class="g-facet-view-more__content">
				<label class="g-facet-set__list-item g-form-checkbox" v-for="value in facet.values.slice(facet.overflow.limit, facet.values.length)" :key="value.label">
					<input class="g-form-checkbox__input" v-model="value.active" type="checkbox" @click="toggleFilter( facet.field, value.type === 'value' ? value.value : [value.low, value.high] )">
					<span class="g-facet-set__list-item-link g-form-checkbox__caption">
						<span class="g-facet-set__list-item-name">{{ value.label }}</span>
						<span class="g-facet-set__list-item-count">({{ value.count }})</span>
					</span>
				</label>
			</div>
		</div>
	</div>

</template>

<script>

	import Search from '../../Search';
	import {DEPARTMENT_FACETS} from '../../data/facets-store';

	export default {
		data() {
			return {
				uniqueId: ''
			}
		},
		props: {
			facet: {
				default() {
					return [];
				}
			}
		},
		methods: {
			toggleFilter ( field, value ) {
				// Check if the facet option is in the facet department map
				const toggledFacet = this.facet.values.find((facet) => {
					if (facet.type === 'range') {
						return facet.low === value[0] && facet.high === value[1];
					}

					return facet.value === value;
				});

				const relatedFacets = DEPARTMENT_FACETS[toggledFacet.value];

				// If it is a related facet and it's being disabled, remove the related facets too.
				if(typeof relatedFacets !== 'undefined' && toggledFacet.active === true) {
					// Facet is being disabled, so clear related facets
					Search.client.states.search.filters = Search.client.states.search.filters.filter(option => !relatedFacets.includes(option.field) );
				}

				Search.client.filter( field, value ).search();
			},
			viewMoreChange(event) {

				if(event.target.checked) {
					event.target.nextElementSibling.innerText = 'View Less';
				} else {
					event.target.nextElementSibling.innerText = 'View More';
				}

			}
		},
		created() {
			this.uniqueId = this._uid;
		}
	}

</script>
